export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "${str}": "",
        "Administracja": "Administration",
        "Akceptuj": "Accept",
        "Aktywne kanały komunikacji": "",
        "Anuluj": "",
        "Bazowy adres domenowy": "",
        "Błąd w kodzie MJML.": "Error in MJML code.",
        "Brak nowych powiadomień.": "",
        "Centrum powiadomień": "Notification center",
        "Data otrzymania": "",
        "Data utworzenia": "Creation date",
        "Data wysłania": "Send date",
        "Dodaj szablon": "Add template",
        "Dodaj wiadomość": "",
        "Dodane przez": "Added by",
        "Domyślna stopka": "",
        "Domyślne logo": "",
        "Edytuj": "Edit",
        "Edytuj komunikaty": "",
        "Edytuj szablon": "Edit template",
        "Edytuj wiadomość": "",
        "HTML": "",
        "Id": "Id",
        "ID": "ID",
        "Jest wymagany do prawidłowego osadzenia logo w treści wiadomości mailowej.": "",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "Channel is required by default. It cannot be disabled for sending notifications via this channel. Only the title and content of the message can be changed.",
        "Kanał wymagany. Nie można go wyłączyć.": "",
        "Kanały": "Channels",
        "Kanały komunikacji": "Communication channels",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "Channels supported by the selected notification type",
        "Klucze": "Keys",
        "Konfiguracja domyślna": "Default configuration",
        "Kopiuj": "Copy",
        "Link do pełnej dokumentacji": "",
        "Liquid": "",
        "Lista jest pusta": "List is empty",
        "MJML": "",
        "Moduł": "",
        "Moje szablony": "",
        "Nazwa": "Name",
        "Nazwa powiadomienia": "Notification name",
        "Nazwa szablonu": "Template name",
        "Nie udało się pobrać powiadomień.": "",
        "Nie udało się wykonać akcji": "",
        "Nie znaleziono żadnych wyników.": "No results found.",
        "Obsługiwane kanały": "",
        "Odznacz": "",
        "Oznacz": "",
        "Oznacz jako nieprzeczytane": "",
        "Oznacz jako przeczytane": "",
        "Oznacz powiadomienia": "",
        "Oznacz wszystkie jako przeczytane": "",
        "Oznacz wybrane jako nieprzeczytane": "",
        "Oznacz wybrane jako przeczytane": "",
        "Poczta wychodząca": "",
        "Pod spodem": "",
        "Podgląd": "",
        "Podgląd i walidacja": "",
        "Położenie widoku podglądu": "",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Potwierdź akceptację": "Confirm approval",
        "Powiadomienia": "",
        "Powiadomienia mailowe": "",
        "Powiadomienie niewidoczne.": "",
        "Powiadomienie testowe zostało wysłane.": "",
        "Powiadomienie wymagane.": "",
        "Powiadomienie wymagane. Nie można go wyłączyć dla wymaganych kanałów.": "",
        "Powiadomienie zbiorowe zostało dodane.": "Bulk notification has been added.",
        "Powiadomienie zbiorowe zostało zaktualizowane.": "Bulk notification has been updated.",
        "Powrót": "Back",
        "Przywróć domyślne": "",
        "Skrócona dokumentacja": "",
        "Status": "",
        "Status dokumentu został zmieniony.": "Document status has been changed.",
        "Status powiadomienia": "Notification status",
        "Status powiadomienia (włączone / wyłączone).": "",
        "Statusy": "",
        "Stopka oraz logo umieszczane są w powiadomieniach wysyłanych kanałem mailowym. Stopka może być skonfigurowana indywidualnie dla każdej wersji jezykowej, logo jest wspólne dla wszystkich.": "",
        "Strona główna": "",
        "System": "System",
        "System powiadomień": "",
        "System szablonów wykorzystuje język Liquid do parsowania kontentu.": "",
        "Szablon został dodany.": "Template has been added.",
        "Szablon został usunięty.": "Template has been deleted.",
        "Szablon został zaktualizowany.": "Template has been updated.",
        "Szablony email": "",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "This channel can send formatted text.",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "This channel cannot send formatted text.",
        "Testuj": "",
        "Treść": "Content",
        "Typy powiadomień": "",
        "Tytuł": "Title",
        "Tytuł powiadomienia": "Notification title",
        "Ustawienia": "",
        "Ustawienia powiadomień zostały zaktualizowane.": "",
        "Usuń": "Delete",
        "Wersje": "Versions",
        "Widoczność w ustawieniach użytkownika.": "",
        "Włączone": "Enabled",
        "Włączony": "",
        "Wpis do kalendarza został usunięty.": "Calendar entry has been deleted.",
        "Wszystko": "",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "Select notification type to see available keys.",
        "wybierz...": "select...",
        "Wyłączone": "",
        "Wyłączony": "",
        "Wysyłaj tym kanałem": "Send via this channel",
        "Wysyłka wiadomości": "",
        "Wyślij do": "Send to",
        "Z boku": "",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and back",
        "Zapisz ustawienia": "",
        "Zaznacz": "",
        "Zmiana hasła": "",
        "Zobacz wszystkie": ""
    }
};
